import React, { useState, useEffect, useLayoutEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../components/Ad.css';
import Header from '../components/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonChalkboard, faClipboardList, faUserPlus, faCreditCard, faIdCard, faUsersBetweenLines, faCalendarAlt, faBookOpenReader, faXmark } from '@fortawesome/free-solid-svg-icons';
import 'react-calendar/dist/Calendar.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons'; // Updated import for new icons
import LearnImage from '../images/learn.jpg'
import Bgc from '../images/Bgc.png'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import axios from '../Axiosinstance';
import Charisma from '.././images/Charisma.png'
import backgroundImage from '../images/erg.png';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Card,
  CardContent,
  TextField,
  CardActionArea,
  Box,
  TablePagination,
  Paper,
  Dialog, DialogTitle, DialogContent, DialogActions, Typography, Grid, DialogContentText,
  Divider, Button
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { Modal, ModalBody, ModalTitle, Spinner } from 'react-bootstrap';
import Loader from '../Loader';
import { faUserGraduate, faUserTie, faLayerGroup, faBookReader, faBook } from '@fortawesome/free-solid-svg-icons';
import Studentreq from './Studentreq'
import { Tabs, Tab, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { faTasks, faProjectDiagram, faBell, faTicketAlt, faBullhorn, faTable } from '@fortawesome/free-solid-svg-icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { InputLabel, FormControl } from '@material-ui/core';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ViewDetailsModal from './ViewDetailsModal';
import { CircularProgress } from "@mui/material";
import StudentSummary from './Studentsummary'
import ActiveSessionsCard from './ActiveSessionsCard'; // adjust path as needed


const Ap = () => {


  return (
    <Box
      className="containerd"
      sx={{
        textAlign: 'center',
        fontFamily: 'Montserrat, sans-serif',
        padding: { xs: '20px', sm: '35px' },
        marginTop: { xs: '0%', sm: '-2%' }, // Adjust margin for different screens
      }}
    >
      <Typography
        className="welcome-heading fangsong"
        variant="h1"
        sx={{
          fontSize: { xs: '2.2rem', sm: '2.8rem' }, // Adjust font size based on screen width
          textTransform: 'uppercase',
          letterSpacing: '0.1rem',
          display: 'inline-block', // Ensure inline behavior for proper alignment
          fontWeight: 'bolder', // Apply bold style
        }}
      >
        <span
          style={{
            fontFamily: 'Courier New, Courier, monospace',
            letterSpacing: '0.1rem',
          }}
        >
          <span style={{ fontSize: '3.0rem' }}>AEG</span>
          <span style={{ fontSize: '3.0rem' }}> International</span>
          <span style={{ fontSize: '3.0rem' }}> College</span>
        </span>
      </Typography>

      <Typography
        className="welcome-heading"
        variant="h4"
        sx={{
          fontSize: { xs: '1.8rem', sm: '2.4rem' }, // Adjust font size for small and large screens
          fontWeight: 'bold',
          marginBottom: '10px',
        }}
      >
        Learning Management System
      </Typography>
    </Box>
  );
};



const WelcomeBoxes = () => {
  const navigate = useNavigate();
  const [hoveredState, setHoveredState] = useState({
    studentRequest: false,
    newRegistration: false,
    payments: false,
    // registration: false,
  });

  const [countStudent, setCountStudent] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showStudentReq, setShowStudentReq] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await axios.get('exisitingstudentrequest/countFalseStatus');
        setCountStudent(response1.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const handleHoverToggle = (box) => {
    setHoveredState((prev) => ({ ...prev, [box]: !prev[box] }));
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const handleOpenStudentReq = () => setShowStudentReq(true);
  const handleCloseStudentReq = () => setShowStudentReq(false);

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{ maxWidth: '1300px', margin: '0 auto' }}>
      <Grid container spacing={4}>

        {/* <Grid item xs={12} sm={4} >
          <Card
            onClick={handleOpenStudentReq}
            onMouseEnter={() => handleHoverToggle('studentRequest')}
            onMouseLeave={() => handleHoverToggle('studentRequest')}
            sx={{
              borderRadius: '15px',
              background: hoveredState.studentRequest ? 'linear-gradient(135deg, #6DD5FA, #FFFFFF)' : 'linear-gradient(135deg, #ffffff, #e0e0e0)',
              transition: 'transform 0.3s, box-shadow 0.3s',
              transform: hoveredState.studentRequest ? 'scale(1.05)' : 'scale(1)',
              boxShadow: hoveredState.studentRequest ? '0px 10px 20px rgba(0, 0, 0, 0.2)' : '0px 4px 15px rgba(0, 0, 0, 0.1)',
              cursor: 'pointer',
            }}
          >
            <CardActionArea>
              <CardContent sx={{ textAlign: 'center' }}>
                <FontAwesomeIcon icon={faUsersBetweenLines} size="3x" style={{ color: '#4A90E2', marginBottom: '15px' }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '10px' }}>Student Requests</Typography>
               <Typography variant="body2" sx={{ marginBottom: '10px' }}>
                  {typeof countStudent === 'undefined' ? 'Loading...' : `${countStudent} requests pending`}
                </Typography>
                <Typography variant="body2" color="textSecondary">View and check existing student request.</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid> */}

        {/* New Registration Card */}
        <Grid item xs={12} sm={6}>
          <Card
            onClick={openModal}
            onMouseEnter={() => handleHoverToggle('newRegistration')}
            onMouseLeave={() => handleHoverToggle('newRegistration')}
            sx={{
              borderRadius: '15px',
              background: hoveredState.newRegistration ? 'linear-gradient(135deg, #6DD5FA, #FFFFFF)' : 'linear-gradient(135deg, #ffffff, #e0e0e0)',
              transition: 'transform 0.3s, box-shadow 0.3s',
              transform: hoveredState.newRegistration ? 'scale(1.05)' : 'scale(1)',
              boxShadow: hoveredState.newRegistration ? '0px 10px 20px rgba(0, 0, 0, 0.2)' : '0px 4px 15px rgba(0, 0, 0, 0.1)',
            }}
          >
            <CardActionArea>
              <CardContent sx={{ textAlign: 'center' }}>
                <FontAwesomeIcon icon={faLayerGroup} size="3x" style={{ color: '#4A90E2', marginBottom: '15px' }} />
                <Typography variant="h6" sx={{ fontSize: 'clamp(20px, 2vw, 24px)', fontWeight: '700', marginBottom: '2px' }}>New Registration</Typography>
                <Typography variant="h6" color="textSecondary">View and manage the New Registration </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Payments Card */}
        <Grid item xs={12} sm={6}>
          <Card
            sx={{
              borderRadius: '15px',
              background: hoveredState.payments
                ? 'linear-gradient(135deg, #6DD5FA, #FFFFFF)'
                : 'linear-gradient(135deg, #ffffff, #e0e0e0)',
              transition: 'transform 0.3s, box-shadow 0.3s',
              transform: hoveredState.payments ? 'scale(1.05)' : 'scale(1)',
              boxShadow: hoveredState.payments
                ? '0px 10px 20px rgba(0, 0, 0, 0.2)'
                : '0px 4px 15px rgba(0, 0, 0, 0.1)',
            }}
            onMouseEnter={() => setHoveredState(prev => ({ ...prev, payments: true }))}
            onMouseLeave={() => setHoveredState(prev => ({ ...prev, payments: false }))}
          >
            <CardActionArea onClick={handleOpen}>
              <CardContent sx={{ textAlign: 'center' }}>
                <FontAwesomeIcon
                  icon={faBookReader}
                  size="3x"
                  style={{ color: '#4A90E2', marginBottom: '15px' }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: 'clamp(20px, 2vw, 24px)',
                    fontWeight: '700',
                    marginBottom: '2px',
                  }}
                >
                  Student Summary
                </Typography>
                <Typography variant="h6" color="textSecondary">
                    View & Download - Student Summary
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Active Online Sessions Card */}
        <Grid item xs={12}>
          <ActiveSessionsCard />
        </Grid>

      </Grid>


      {/* Modals */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="course-categories-dialog"
        fullScreen
      >
        <DialogTitle id="course-categories-dialog" >
          <Typography variant="h6">
            Student Summary
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <FontAwesomeIcon icon={faXmark} />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <StudentSummary />
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{
              backgroundColor: '#ff0000',
              color: 'white',
              '&:hover': {
                backgroundColor: '#cc0000'
              },
              maxWidth: '120px'
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Modal show={showModal} onHide={closeModal} dialogClassName="modal-fullscreen">
        <Modal.Header closeButton>
          <Modal.Title>New Registration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tablerow />
        </Modal.Body>
        <Modal.Footer>
          <Button style={{ backgroundColor: '#ff0000', color: 'white', borderColor: '#ff0000', maxWidth: '120px' }} onClick={closeModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showStudentReq} onHide={handleCloseStudentReq} dialogClassName="modal-fullscreen">
        <Modal.Header closeButton>
          <Modal.Title>Student Requests</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Studentreq />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseStudentReq}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    </Box>
  );
};

const Dashboard = () => {
  const [studentdata1, setstudentdata1] = useState(0);
  const [staffdata2, setstaffdata2] = useState(0);
  const [batchdata3, setbatchdata3] = useState(0);
  const [coursesdata4, setcoursesdata4] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [response1, response2, response3, response4] = await Promise.all([
          axios.get('count/active'),
          axios.get('facilitator/count'),
          axios.get('batch/count'),
          axios.get('course/count'),
        ]);
        setstudentdata1(response1.data);
        setstaffdata2(response2.data);
        setbatchdata3(response3.data);
        setcoursesdata4(response4.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const totals = [
    { name: 'Total Students', count: studentdata1, icon: faUserGraduate, path: '/Allstudent' },
    { name: 'Total Staff', count: staffdata2, icon: faPersonChalkboard, path: '/Facilitor' },
    { name: 'Total Courses', count: batchdata3, icon: faChalkboardTeacher, path: '/Batches' },
    { name: 'Alumini Students', icon: faCalendarAlt, path: '/Alumistudent' }, ,
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const [hoverIndex, setHoverIndex] = useState(null);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        backgroundImage: `url(${Bgc})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center calc(50% + 10px)',
        maxWidth: '1500px',
        width: '100%', // Ensures responsiveness
        margin: '0 auto',
        borderRadius: '15px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center', // Centers items
          width: '100%',
          gap: '15px', // Adds spacing without margin issues
        }}
      >
        {totals.map((item, index) => (
          <div
            key={index}
            onClick={() => handleNavigation(item.path)}
            style={{
              flex: '1 1 calc(50% - 30px)', // Allows two items per row, with spacing
              maxWidth: '650px', // Prevents items from stretching too much
              height: 'auto', // Adapts height dynamically
              minHeight: '120px', // Ensures a minimum height
              borderRadius: '30px',
              background: hoverIndex === index
                ? 'linear-gradient(135deg, #6DD5FA, #FFFFFF)'
                : 'linear-gradient(135deg, #ffffff, #e0e0e0)',
              boxShadow: hoverIndex === index
                ? '0 10px 20px rgba(0, 0, 0, 0.2)'
                : '0 4px 10px rgba(0, 0, 0, 0.1)',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '15px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              transform: hoverIndex === index ? 'scale(1.02)' : 'scale(1)',
            }}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            <div style={{ flex: 1, textAlign: 'left' }}>
              <div style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: '700', marginBottom: '5px', color: '#007BFF' }}>
                {item.count}
              </div>
              <div style={{ fontSize: 'clamp(18px, 3vw, 30px)', fontWeight: '800', color: '#343A40' }}>
                {item.name}
              </div>
            </div>
            <div
              style={{
                width: '80px', // Adjusted for responsiveness
                height: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                backgroundColor: hoverIndex === index ? '#007BFF' : '#F0F0F0',
                transition: 'background-color 0.3s ease',
              }}
            >
              <FontAwesomeIcon
                icon={item.icon}
                style={{ fontSize: 'clamp(35px, 5vw, 55px)', color: hoverIndex === index ? '#ffffff' : '#343A40' }} // Responsive font size
              />
            </div>
          </div>
        ))}
      </div>
    </div>

  );
};



const Tablerow = () => {
  const [students, setStudents] = useState([]);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [hoveredStudentDetails, setHoveredStudentDetails] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [openedit, setOpenedit] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState('');
  const [selectedStudentDetails, setSelectedStudentDetails] = useState(null);
  const [isEditModalOpen, setEditModalOpen] = useState(false);

  const [showEmploymentFields, setShowEmploymentFields] = useState(false); // State to manage visibility of employment fields
  const [editFormData, setEditFormData] = useState({
    fullname: '',
    email: '',
    nric: '',
    passport: '',
    enrolledDate: '',
    startModulus: '',
    passportExpiryDate: '',
    course: '',
    status: '',
    phone: '',
    officephone: '',
    gender: '',
    dob: '',
    password: '',
    religion: '',
    citizenship: '',
    address: '',
    currentAddress: '',
    fatherName: '',
    fatherPhoneNo: '',
    brotherName: '',
    brotherPhoneNo: '',
    institutionDetails: [],
    workExpirences: [],
    customId: '',
    relationship: "",
    proofType: "",

  });



  const fetchStudents = () => {
    // setLoading(true);
    axios.get('registrationadvances/registration/status?status=New')
      .then(response => {
        setStudents(response.data);
        // setLoading(false);
        console.log(response.data);
      })
      .catch(error => {
        // setLoading(false);
        console.error('Error fetching data:', error);
      });
  };
  // Fetch students on component mount
  useEffect(() => {
    fetchStudents();
  }, [isEditModalOpen]); // Runs once on mount

  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleApprove = (id, student) => {


    // console.log('Student ID:', student.customId);
    setSelectedStudentId(id);
    setShowConfirmation(true);
  };

  const confirmApprove = () => {
    if (selectedStudentId) {
      setLoading(true); // Set loading to true when the process starts
      axios
        .post('/registrationadvances/approvestudent', null, {
          params: { Id: selectedStudentId }, // Pass the student ID as a request parameter
        })
        .then((response) => {
          console.log('Approval successful:', response.data);

          fetchStudents(); // Fetch updated list of students
          toast.success('Student approved successfully', {
            position: 'bottom-right',
            autoClose: 3000, // Close the notification after 3 seconds
          });
        })
        .catch((error) => {
          console.error('Error approving student:', error);
          toast.error('Failed to approve the student. Please try again.', {
            position: 'bottom-right',
            autoClose: 3000,
          });
        })
        .finally(() => {
          setLoading(false); // Set loading to false when the process ends
          setShowConfirmation(false); // Reset the confirmation dialog
          setSelectedStudentId(null);
        });
    }
  };

  const cancelApprove = () => {
    setShowConfirmation(false);
    setSelectedStudentId(null);
  };



  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this student?");
    if (confirmDelete) {
      try {
        const response = await axios.delete(`/registrationadvances/${id}`);
        console.log("Response:", response.data);
        // Update students list
        const updatedStudents = students.filter((student) => student.id !== id);
        setStudents(updatedStudents);
        alert("Student successfully deleted!");
      } catch (error) {
        console.error("Error deleting student:", error.response || error.message);
        alert("Failed to delete the student. Please check the console for details.");
      }
    }
  };




  const handleHover = (studentDetails) => {
    setHoveredStudentDetails(studentDetails);
  };

  const handleLeave = () => {
    setHoveredStudentDetails(null);
  };


  const handleViewClick = (student) => {
    setSelectedStudentDetails(student);
    setOpen(true);
    // console.log(selectedStudentDetails);
  };
  const handleEditClick = (student) => {
    setEditFormData(student);
    setEditModalOpen(true);
  };

  const closeEditModal = () => {
    setEditModalOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedStudentDetails(null);
    // setStudents(null);
  };




  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };



  // Filter students by search term
  const filteredStudents = students.filter((student) =>
    student.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const moduleDetailsMap = selectedStudentDetails?.batch?.moduleDetails.reduce((map, module) => {
    map[module.id] = module.moduleName;
    return map;
  }, {}) || {};

  const totalModules = Object.keys(moduleDetailsMap).length;

  const getModuleName = (startModulus) => {
    const adjustedId = ((startModulus - 1 + totalModules) % totalModules) + 1;
    return moduleDetailsMap[adjustedId] || `Unknown Module (ID: ${adjustedId})`;
  };

  const formatDate1 = (dateStr) => {
    const date = new Date(dateStr);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('en-GB', options);
  };



  return (
    <div className="container-responsive" style={{ marginRight: '10%', marginLeft: '10%', marginBottom: '0px' }}>
      {loading ? ( // Render loader if loading is true
        <Dialog
          open={loading}
          aria-labelledby="loading-dialog-title"
          aria-describedby="loading-dialog-description"
          fullWidth
          maxWidth="sm"
          PaperProps={{
            style: {
              borderRadius: 8,
            },
          }}
        >
          <DialogTitle id="loading-dialog-title" style={{ textAlign: 'center' }}>
            Please Wait
          </DialogTitle>
          <DialogContent style={{ textAlign: 'center' }}>
            <CircularProgress color="primary" />
            <Typography id="loading-dialog-description" sx={{ mt: 2 }}>
              Please wait while the process.
            </Typography>
          </DialogContent>
        </Dialog>

      ) : (
        <>
          <ToastContainer />
          <Dialog open={showConfirmation} onClose={cancelApprove}>
            <DialogTitle>Approving Student</DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to approve this student for this batch?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={confirmApprove}
                variant="contained"
                color="success"
                disabled={loading}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
              >
                {loading ? 'Approving...' : 'Approve'}
              </Button>
              <Button
                onClick={cancelApprove}
                variant="contained"
                color="error"
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>

          <h2 className="heading" align="center" style={{ color: '#FFFFFF', fontSize: '28px' }}>New Registration</h2>
          <Box sx={{ width: '100%', p: { xs: 1, sm: 2 } }}>
            {/* Search Field */}
            <TextField
              label="Search by Name"
              variant="outlined"
              fullWidth
              margin="normal"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />


            {/* Table */}
            <TableContainer component={Paper} sx={{ maxHeight: '75vh', overflowX: 'auto' }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#f2f2f2' }}>
                    {['S.No', 'Name', 'Phone No', 'Course', 'Status', 'Action', 'View/Edit'].map((header, idx) => (
                      <TableCell
                        key={idx}
                        align="center"
                        sx={{ fontWeight: 'bold', fontSize: '1rem', borderBottom: '2px solid #ccc' }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredStudents.length > 0 ? (
                    filteredStudents
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((student, index) => (
                        <TableRow
                          key={student.id}
                          onMouseEnter={() => handleHover(student)}
                          onMouseLeave={handleLeave}
                          hover
                        >
                          <TableCell align="center">{page * rowsPerPage + index + 1}</TableCell>

                          <TableCell align="center">
                            <Tooltip
                              title={
                                hoveredStudentDetails ? (
                                  <Box>
                                    <div><strong>Name:</strong> {hoveredStudentDetails.name}</div>
                                    <div><strong>Email:</strong> {hoveredStudentDetails.email}</div>
                                    <div><strong>Phone:</strong> {hoveredStudentDetails.phone}</div>
                                    <div><strong>Address:</strong> {hoveredStudentDetails.address}</div>
                                  </Box>
                                ) : ''
                              }
                            >
                              <span>{student.name}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="center">{student.phone}</TableCell>
                          <TableCell align="center">{student.batch ? student.batch.course : 'General'}</TableCell>
                          <TableCell align="center">{student.status}</TableCell>

                          {/* Approve / Delete Action */}
                          <TableCell align="center">
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                              <IconButton
                                onClick={() => handleApprove(student.id, student)}
                                sx={{ bgcolor: 'success.main', color: 'white', '&:hover': { bgcolor: 'success.dark' }, p: 1 }}
                                size="small"
                              >
                                <CheckIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                onClick={() => handleDelete(student.id)}
                                sx={{ bgcolor: 'error.main', color: 'white', '&:hover': { bgcolor: 'error.dark' }, p: 1 }}
                                size="small"
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </TableCell>

                          {/* View / Edit Button */}
                          <TableCell align="center">
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                justifyContent: 'center',
                                gap: 1,
                                mt: { xs: 1, sm: 0 }
                              }}
                            >
                              <Button
                                variant="contained"
                                size="small"
                                sx={{ bgcolor: 'primary.main', '&:hover': { bgcolor: 'primary.dark' }, minWidth: '80px' }}
                                onClick={() => handleViewClick(student)}
                              >
                                View
                              </Button>
                              <Button
                                variant="contained"
                                size="small"
                                sx={{ bgcolor: 'primary.main', '&:hover': { bgcolor: 'primary.dark' }, minWidth: '80px' }}
                                onClick={() => handleEditClick(student)}
                              >
                                Edit
                              </Button>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={7} align="center" sx={{ py: 3, color: '#555' }}>
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              {/* Pagination */}
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredStudents.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </Box>

          <Dialog fullScreen open={open} onClose={handleClose} >

            <DialogContent>
              <Grid container justifyContent="center" spacing={3}>
                <Paper elevation={3} style={{
                  padding: '32px', backgroundColor: '#ffffff', borderRadius: '12px',
                  maxWidth: '1200px', margin: '40px auto', width: '100%',
                }}>
                  <Typography variant="h5" gutterBottom style={{
                    color: '#3f51b5', borderBottom: '3px solid #3f51b5', paddingBottom: '12px',
                    fontWeight: 'bold', textAlign: 'center'
                  }}>
                    Basic Personal Information
                  </Typography>
                  {selectedStudentDetails ? (<Grid container spacing={4}>

                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600', display: 'inline' }}>
                        <i className="fas fa-user"></i> Full Name:
                      </Typography>
                      <Typography variant="body1" style={{ fontWeight: '600', display: 'inline' }}>
                        {' '}{selectedStudentDetails.name || '-'}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-envelope"></i> Email: {selectedStudentDetails.email || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-phone"></i> Phone: {selectedStudentDetails.phone || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-phone"></i> proofType: {selectedStudentDetails.proofType || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-id-card"></i> NRIC: {selectedStudentDetails.nric || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-venus-mars"></i> Gender: {selectedStudentDetails.gender || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-calendar-alt"></i> DOB: {formatDate(selectedStudentDetails.dob) || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-book"></i> Course: {selectedStudentDetails.course || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-passport"></i> Citizenship: {selectedStudentDetails.citizenship || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-user-tie"></i> Relationship: {selectedStudentDetails.relationship || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-user-tie"></i> Emergency Contact Name: {selectedStudentDetails.fatherName || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-phone-square-alt"></i> Emergency Contact Number: {selectedStudentDetails.fatherPhoneNo || '-'}</Typography>
                    </Grid>
                    {/* <Grid item xs={12} md={6}> */}
                    {/* <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-user"></i> Brother's Name: {selectedStudentDetails.brotherName || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-phone"></i> Brother's Phone No: {selectedStudentDetails.brotherPhoneNo || '-'}</Typography> */}
                    {/* </Grid> */}
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-pray"></i> Religion: {selectedStudentDetails.religion || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-map-marker-alt"></i> Singapore Address: {selectedStudentDetails.currentAddress || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" style={{ fontWeight: '600' }}><i className="fas fa-home"></i> Home Address: {selectedStudentDetails.address || '-'}</Typography>
                    </Grid>


                    <TableContainer component={Paper} style={{ margin: '20px', padding: '20px' }}>
                      <Typography variant="h6" gutterBottom style={{ color: '#3f51b5', borderBottom: '3px solid #3f51b5', paddingBottom: '12px', marginTop: '10px', fontWeight: 'bold', textAlign: 'start' }}>Schedule Details
                      </Typography>

                      <Table striped bordered hover responsive>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ fontWeight: 'bold' }} >Start Date</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>End Date</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Module</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(Array.isArray(selectedStudentDetails?.scheduleDate) ? selectedStudentDetails.scheduleDate : []).map((item, index) => (
                            <TableRow key={index}>
                              <TableCell>{formatDate1(item.startDate)}</TableCell>
                              <TableCell>{formatDate1(item.endDate)}</TableCell>
                              <TableCell>{getModuleName(item.startModulus)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <Typography variant="h6" gutterBottom style={{ color: '#3f51b5', borderBottom: '3px solid #3f51b5', paddingBottom: '12px', marginTop: '10px', fontWeight: 'bold', textAlign: 'start' }}>Institution Details
                      </Typography>
                      <Table striped bordered hover responsive>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ fontWeight: 'bold' }}>Institution</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Year</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Qualifications Achieved</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedStudentDetails.institutionDetails && selectedStudentDetails.institutionDetails.length > 0 ? (
                            selectedStudentDetails.institutionDetails.map((institution, index) => (
                              <TableRow key={index}>
                                <TableCell>{institution.institution}</TableCell>
                                <TableCell>{institution.fromYear} - {institution.toYear}</TableCell>
                                <TableCell>{institution.qualificationsAchieved}</TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={3} className="text-center">
                                No data available
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <Typography variant="h6" gutterBottom style={{ color: '#3f51b5', borderBottom: '3px solid #3f51b5', paddingBottom: '12px', marginTop: '10px', fontWeight: 'bold', textAlign: 'start' }}>                      Employment Details
                      </Typography>

                      <Table striped bordered hover responsive>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ fontWeight: 'bold' }}>Company</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Year</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Position</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedStudentDetails.workExpirences && selectedStudentDetails.workExpirences.length > 0 ? (
                            selectedStudentDetails.workExpirences.map((work, index) => (
                              <TableRow key={index}>
                                <TableCell>{work.name}</TableCell>
                                <TableCell>{work.fromYear}-{work.toYear}</TableCell>
                                <TableCell>{work.position}</TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={3} className="text-center">
                                No data available
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>

                    </TableContainer>
                    <TableContainer component={Paper} style={{ margin: '20px' }}>
                      <Typography variant="h6" gutterBottom style={{ color: '#3f51b5', borderBottom: '3px solid #3f51b5', paddingBottom: '12px', marginTop: '10px', fontWeight: 'bold', textAlign: 'start' }}>
                        Uploaded Documents
                      </Typography>
                      <Table>

                        <TableBody>
                          {selectedStudentDetails.nricdoc && (
                            <TableRow>
                              <TableCell style={{ fontWeight: '600', padding: '16px' }}>NRIC Document</TableCell>
                              <TableCell style={{ padding: '16px' }}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => window.open(selectedStudentDetails.nricdoc, '_blank')}
                                  style={{ marginRight: '8px' }}
                                >
                                  View
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}

                          {selectedStudentDetails.passportdoc && (
                            <TableRow>
                              <TableCell style={{ fontWeight: '600', padding: '16px' }}>Passport Document</TableCell>
                              <TableCell style={{ padding: '16px' }}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => window.open(selectedStudentDetails.passportdoc, '_blank')}
                                  style={{ marginRight: '8px' }}
                                >
                                  View
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}

                          {selectedStudentDetails.educationdoc && (
                            <TableRow>
                              <TableCell style={{ fontWeight: '600', padding: '16px' }}>Education Document</TableCell>
                              <TableCell style={{ padding: '16px' }}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => window.open(selectedStudentDetails.educationdoc, '_blank')}
                                  style={{ marginRight: '8px' }}
                                >
                                  View
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}

                          {selectedStudentDetails.profileUrl && (
                            <TableRow>
                              <TableCell style={{ fontWeight: '600', padding: '16px' }}>Profile  </TableCell>
                              <TableCell style={{ padding: '16px' }}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => window.open(selectedStudentDetails.profileUrl, '_blank')}
                                  style={{ marginRight: '8px' }}
                                >
                                  View
                                </Button>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>


                    </TableContainer>

                  </Grid>
                  ) : (
                    <Typography style={{ marginTop: '20px', color: 'red', textAlign: 'center' }}>
                      No information available.
                    </Typography>
                  )}
                </Paper>
              </Grid>
            </DialogContent>


            <DialogActions>
              <Button onClick={handleClose} style={{ backgroundColor: '#ff0000', color: 'white', borderColor: '#ff0000', maxWidth: '120px' }}>
                Close
              </Button>
            </DialogActions>
          </Dialog>

          <Modal fullscreen show={isEditModalOpen} onHide={closeEditModal}>
            <Modal.Header>
              <Modal.Title>Edit Student </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ViewDetailsModal onAction={closeEditModal} editForm={editFormData} />
            </Modal.Body>
            <Modal.Footer>

              {/* <Button onClick={handleSaveEdit} variant="contained" color="primary" style={{ backgroundColor: 'green', color: 'white' }}>
                Update
              </Button> */}

              <Button onClick={closeEditModal} variant="contained" color="secondary" style={{ backgroundColor: 'red', color: 'white', maxWidth: '120px' }} >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

        </>
      )}
    </div>
  )
}

const tabData = [
  {
    id: 'tab1',
    title: 'Students',
    icon: faTasks,
    tableHeaders: ['ID', 'Name', 'Image', 'Email', 'Phone', 'Gender'],
    data: [
      { id: 1, name: 'John Doe', image: 'img1.jpg', email: 'john@example.com', phone: '123-456-7890', gender: 'Male' },
      { id: 2, name: 'Jane Doe', image: 'img2.jpg', email: 'jane@example.com', phone: '987-654-3210', gender: 'Female' },
      { id: 3, name: 'Michael Smith', image: 'img3.jpg', email: 'michael@example.com', phone: '456-789-0123', gender: 'Male' },
    ]
  },
  {
    id: 'tab2',
    title: 'Diploma',
    icon: faProjectDiagram,
    tableHeaders: ['ID', 'Name', 'Image', 'Email', 'Phone', 'Gender'],
    data: [
      { id: 1, name: 'Emily Johnson', image: 'img4.jpg', email: 'emily@example.com', phone: '111-222-3333', gender: 'Female' },
      { id: 2, name: 'Daniel Williams', image: 'img5.jpg', email: 'daniel@example.com', phone: '444-555-6666', gender: 'Male' },
      { id: 3, name: 'Olivia Brown', image: 'img6.jpg', email: 'olivia@example.com', phone: '777-888-9999', gender: 'Female' },
    ]
  },
  {
    id: 'tab3',
    title: 'WSQ',
    icon: faBell,
    tableHeaders: ['ID', 'Name', 'Image', 'Email', 'Phone', 'Gender'],
    data: [
      { id: 1, name: 'William Wilson', image: 'img7.jpg', email: 'william@example.com', phone: '111-222-3333', gender: 'Male' },
      { id: 2, name: 'Sophia Anderson', image: 'img8.jpg', email: 'sophia@example.com', phone: '444-555-6666', gender: 'Female' },
      { id: 3, name: 'Alexander Martinez', image: 'img9.jpg', email: 'alexander@example.com', phone: '777-888-9999', gender: 'Male' },
    ]
  },
  {
    id: 'tab4',
    title: 'Staff Details',
    icon: faTicketAlt,
    tableHeaders: ['ID', 'Name', 'Image', 'Email', 'Phone', 'Gender'],
    data: [
      { id: 1, name: 'Emma Garcia', image: 'img10.jpg', email: 'emma@example.com', phone: '111-222-3333', gender: 'Female' },
      { id: 2, name: 'James Lopez', image: 'img11.jpg', email: 'james@example.com', phone: '444-555-6666', gender: 'Male' },
      { id: 3, name: 'Ella Rodriguez', image: 'img12.jpg', email: 'ella@example.com', phone: '777-888-9999', gender: 'Female' },
    ]
  },
];

const useStyles = makeStyles((theme) => ({
  header: {
    borderBottom: '1px solid #bdc3c9',
    paddingBottom: '10px',
    marginBottom: '20px',
    fontSize: '20px',
  },
  customNavLink: {
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'inherit',
  },
  inputGroup: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
}));


const Adhome = () => {
  return (
    <div
      style={{
        position: 'relative',
        minHeight: '100vh',
        overflow: 'hidden', // Prevents content from overflowing
      }}
    >
      {/* Background Image with Opacity */}
      <div
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover', // Make the image fill the container
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          opacity: 0.1,
          zIndex: 0,
        }}
      />


      <Header />
      <br /> <br />
      <div
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
          zIndex: 1,
          marginBottom: '5%'
        }}
      >
        <Ap />
        <Dashboard />
        <br /> <br />
        <WelcomeBoxes />
      </div>

      {/* Charisma.png at Bottom Right */}
      {/* <div
        style={{
          position: 'absolute',
          bottom: '30px', // Adjust to desired distance from the bottom
          right: '30px', // Adjust to desired distance from the right
          opacity: 0.5, // Transparency for the image
          zIndex: 1, // Ensure it is below other UI elements
          pointerEvents: 'none',
        }}
      >
        <img
          src={Charisma}
          alt="Charisma"
          style={{
            maxWidth: '120px', // Adjust the size as needed
            maxHeight: '120px',
          }}
        />
      </div> */}
    </div>
  );
};




export default Adhome;  